<template>
    <xx-enum-text :value="value" :dicCode="dicCode"/>
</template>

<script>
export default {
    name: 'formatDicCode',
    props: {
        value: { type: Number },
        scope: { type: Object },
        dicCode: { type: String }
    },
};
</script>
